export function popups() {
    const $body = $("body");
    const popup = $(".popup");
    const popupClose = $(".popup .popup-close");
    let currentPopupInfo;
    $body.on("click", ".popup-opener", function (e) {
        e.preventDefault();
        let $this = $(this);
        let target = $this.data("href");
        $(target).addClass("popup-info-show").slideDown(100);
        if ($this.data("video-src")) {
            let videoSrc = $this.data("video-src");
            $("<iframe>", {
                src: videoSrc + "&amp;dnt=1&amp;app_id=122963&amp;autoplay=1&autopause=0&amp;title=0&amp;sidedock=0&amp;",
                allow: "autoplay",
                fullscreen: true,
                allowfullscreen: true,
                scrolling: "no"
            }).appendTo($(target));
        }
        setTimeout(function () {
            $body.addClass("popup-opened");
            window.initCustomScroll();
        }, 200);
    });
    popupClose.on("click", function (e) {
        e.preventDefault();
        closePopup();
    });
    $(document).keydown(function (e) {
        if (e.keyCode == 27) {
            closePopup();
        }
    });

    function closePopup() {
        $body.removeClass("popup-opened");
        currentPopupInfo = popup.find(".popup-info-show");
        setTimeout(function () {
            if (currentPopupInfo.hasClass("video-popup")) {
                currentPopupInfo.find("iframe").remove();
            }
            currentPopupInfo.removeClass("popup-info-show").slideUp(100);
        }, 500);
    }

    $(window).on("resize", function () {
        window.initCustomScroll();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/popups.js